<template>
  <div id="teacherProfile">
    <v-container fluid>
      <v-row>
        <v-col cols="12" order="3" order-sm="1" class="col-nopadding">
          <h2 class="section-title text-center">
            {{ $t("Please set appropriate appointment") }}
          </h2>
        </v-col>
        <v-col cols="12" sm="2" order="1" order-sm="2">
          <v-card class="mx-auto" max-width="100%">
            <v-card-text>
              <div class="details text-center">
                <img
                  :src="
                    teacherInfo.img != ''
                      ? teacherInfo.img
                      : teacherInfo.title == 'mr'
                      ? defaultAvaterMale
                      : defaultAvaterfeMale
                  "
                  class="thumbnial"
                  style="cursor: pointer"
                  alt
                />

                <p class="text-center teacher-name">
                  <span class="main-color">{{ teacherInfo.name }}</span>
                </p>

                <p class="rate-stars text-center" v-if="count >= 3">
                  <v-icon
                    :color="teacherInfo.rating >= 1 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                  <v-icon
                    :color="teacherInfo.rating >= 2 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                  <v-icon
                    :color="teacherInfo.rating >= 3 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                  <v-icon
                    :color="teacherInfo.rating >= 4 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                  <v-icon
                    :color="teacherInfo.rating >= 5 ? '#FDCD25' : '#bfbfbf'"
                    >star_rate</v-icon
                  >
                </p>
              </div>
              <div class="student-info">
                <div class="main-color display-flex">
                  <p>
                    <v-icon class="main-color">payment</v-icon>
                  </p>
                  <p>
                    {{ $t("Hour price start from") }}
                    {{ teacherInfo.hour_price }} {{ $t("currency") }}
                  </p>
                </div>
                <div class="main-color display-flex">
                  <p>
                    <v-icon class="main-color">book</v-icon>
                  </p>
                  <p>{{ teacherInfo.curriculum }}</p>
                </div>
                <div
                  class="main-color display-flex"
                  v-for="(grade, index) in teacherInfo.grades"
                  :key="index"
                >
                  <p>
                    <v-icon class="main-color">language</v-icon>
                  </p>
                  <p>
                    <span>{{ grade }}</span>
                  </p>
                </div>
                <div class="socials text-center">
                  <a
                    :href="teacherInfo.facebook"
                    target="_blank"
                    v-if="teacherInfo.facebook"
                  >
                    <i class="fab fa-facebook-square"></i>
                  </a>

                  <a
                    :href="teacherInfo.twitter"
                    target="_blank"
                    v-if="teacherInfo.twitter"
                  >
                    <i class="fab fa-twitter-square"></i>
                  </a>
                  <a
                    :href="teacherInfo.instagram"
                    target="_blank"
                    v-if="teacherInfo.instagram"
                  >
                    <i class="fab fa-instagram"></i>
                  </a>
                  <a
                    :href="teacherInfo.linkedIn"
                    target="_blank"
                    v-if="teacherInfo.linkedIn"
                  >
                    <i class="fab fa-linkedin"></i>
                  </a>
                </div>
              </div>
              <div class="text-center">
                <v-btn class="editbtn" to="/teacher/profilesettings?edit=true">
                  <v-icon class="second-color">edit</v-icon>
                  {{ $t("editInfo") }}
                </v-btn>
              </div>
            </v-card-text>
          </v-card>

          <div class="rateSection" v-if="count >= 3">
            <v-card class="mx-auto" max-width="100%">
              <v-card-text>
                <h3 class="main-color">
                  <strong>
                    {{ $t("studentEvaluation") }}
                  </strong>
                </h3>
                <div
                  class="rating"
                  v-for="(item, index) in ratingArray"
                  :key="index"
                >
                  <div class="item">
                    <p class="main-color">
                      {{ item.question }} ({{ item.count }})
                    </p>
                    <div class="rate">
                      <v-icon
                        :color="item.avg_rating >= 1 ? '#FDCD25' : '#bfbfbf'"
                        >star_rate</v-icon
                      >
                      <v-icon
                        :color="item.avg_rating >= 2 ? '#FDCD25' : '#bfbfbf'"
                        >star_rate</v-icon
                      >
                      <v-icon
                        :color="item.avg_rating >= 3 ? '#FDCD25' : '#bfbfbf'"
                        >star_rate</v-icon
                      >
                      <v-icon
                        :color="item.avg_rating >= 4 ? '#FDCD25' : '#bfbfbf'"
                        >star_rate</v-icon
                      >
                      <v-icon
                        :color="item.avg_rating >= 5 ? '#FDCD25' : '#bfbfbf'"
                        >star_rate</v-icon
                      >
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
        <v-col cols="12" sm="8" order="4" order-sm="3" class="col-nopadding">
          <v-row class="fill-height">
            <v-col>
              <v-row>
                <v-col cols="12" sm="6" class="pa-0">
                  <div class=" mb-2">
                    <v-btn class="primary-btn" @click="addEvent">{{
                      $t("addAppointment")
                    }}</v-btn>
                    <v-btn class="primary-btn  mx-2" @click="addGroupEvent()">{{
                      $t("Add Group Session")
                    }}</v-btn>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  class="pa-0 "
                  :class="locale == 'ar' ? 'text-left' : 'text-right'"
                >
                  <v-btn
                    class="primary-btn"
                    v-if="!showGroups"
                    @click="showGroupsSession()"
                    >{{ $t("Show Groups") }}</v-btn
                  >
                  <v-btn
                    class="primary-btn"
                    v-if="showGroups"
                    @click="showCalendar()"
                    >{{ $t("Show Calendar") }}</v-btn
                  >
                </v-col>
              </v-row>
              <CalendarComponent
                :events="events"
                v-on:resetData="getEvent"
                v-if="!showGroups"
              />
              <v-row v-if="showGroups">
                <v-col
                  cols="6"
                  sm="4"
                  v-for="(session, i) in sessionsGroups"
                  :key="i"
                >
                  <teacherGroupCard :session="session">
                    <v-btn
                      class="third-btn mt-2"
                      @click="openGroupDetailsDialog(i)"
                      v-if="session.lessons && session.lessons.length > 1"
                      >{{ $t("Show Details") }}</v-btn
                    >
                  </teacherGroupCard>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" order="2" order-sm="4">
          <v-card class="mx-auto" max-width="100%">
            <v-card-text>
              <h3 class="main-color text-center">
                {{ $t("subjects") }}
              </h3>
              <div
                class="subject"
                v-for="(subjectsArray, gradeName) in teacherInfo.subjects"
                :key="gradeName"
                style="margin-bottom:15px"
              >
                <h3 class="main-color">{{ gradeName }}</h3>
                <div v-for="(subject, index) in subjectsArray" :key="index">
                  <p class="main-color subject-title  mt-4 mb-4">
                    {{ subject.name }}
                  </p>
                  <div class="second-color subj-price display-flex">
                    <p>
                      <v-icon class="second-color">payment</v-icon>
                    </p>
                    <p>
                      {{ subject.teacher_fees }} {{ $t("currency") }}
                      {{ $t("on hour") }}
                    </p>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
          <v-card
            class="mx-auto"
            max-width="100%"
            v-if="teacherInfo.teaching_experience"
          >
            <v-card-text>
              <h3 class="main-color text-center">
                {{ $t("teaching_experience") }}
              </h3>
              <p class="main-color subj-title">
                {{ teacherInfo.teaching_experience.slice(0, 100) }}
              </p>
              <v-btn
                class="green-border-btn"
                v-if="teacherInfo.teaching_experience.length > 100"
                @click="teachingDialog = true"
                >{{ $t("Watch More") }}</v-btn
              >
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- single Dialog -->
    <singleAppointmentDialog
      v-if="singleDialog"
      :dialog="singleDialog"
      @closeSingleDialog="closeSingleDialog"
      @getEvent="getEvent"
      @showSnack="showSnack"
    />

    <!-- group Dialog -->
    <groupAppointmentDialog
      v-if="groupDialog"
      :dialog="groupDialog"
      @closeGroupDialog="closeGroupDialog"
      @getEvent="getEvent"
      @showSnack="showSnack"
    />

    <Snack ref="snack"></Snack>

    <!-- watch more Dialog -->
    <v-dialog v-model="teachingDialog" max-width="600">
      <v-card>
        <div
          class="close-btn"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn color text @click="teachingDialog = false">
            <v-icon class="main-color">close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="headline main-color">{{
          $t("teaching_experience")
        }}</v-card-title>

        <div>
          <v-container>
            <v-row>
              <v-col>
                <p class="text-center">{{ teacherInfo.teaching_experience }}</p>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card>
    </v-dialog>

    <!-- Group session show details dialog -->
    <groupSessionDetails
      :dialog="groupSessionDialog"
      :selectedRepeatedSesions="selectedRepeatedSesions.lessons"
      @closeDialog="closeGroupSessionDialog"
    />
  </div>
</template>

<script>
import CalendarComponent from "../../components/CalendarComponent";
import singleAppointmentDialog from "../../components/teacherAppointments/singleAppointmentDialog";
import groupAppointmentDialog from "../../components/teacherAppointments/groupAppointmentDialog";
import groupSessionDetails from "../../components/teacherAppointments/groupSessionDetails";
import teacherGroupCard from "../../components/teacherAppointments/teacherGroupCard";
export default {
  name: "teacherProfile",
  components: {
    CalendarComponent,
    singleAppointmentDialog,
    groupAppointmentDialog,
    groupSessionDetails,
    teacherGroupCard,
  },
  data() {
    return {
      selectedRepeatedSesions: [],
      groupSessionDialog: false,
      sessionsGroups: [],
      showGroups: false,
      teachingDialog: false,
      singleDialog: false,
      groupDialog: false,
      events: [],
      defaultImg: require("../../assets/images/women.png"),
      teacherInfo: {
        name: "داليا",
        // general_rate: "",
        // reviewers_num: "",
        hour_price: "5",
        grades: [],
        curriculum: "لغة عربية",
        facebook: "",
        twitter: "",
        instagram: "",
        linkedIn: "",
        // rating: [{ name: "", rate: "" }],
        subjects: [{ name: "", teacher_fees: "", website_fees: "" }],
        teaching_experience: "",
      },
      count: 0,
      ratingArray: [],
      editDialog: true,
      teacherId: "",
    };
  },

  methods: {
    openGroupDetailsDialog(index) {
      this.groupSessionDialog = true;
      this.selectedRepeatedSesions = this.sessionsGroups[index];
    },
    closeGroupSessionDialog() {
      this.groupSessionDialog = false;
    },
    showGroupsSession() {
      this.getSessionsGroups();
      this.showGroups = true;
    },
    showCalendar() {
      this.showGroups = false;
    },
    showSnack() {
      const str = this.$i18n.t("The appointment has been added");
      this.$refs.snack.sendSuccessAlert(str);
    },
    addEvent() {
      this.singleDialog = true;
    },
    addGroupEvent() {
      this.groupDialog = true;
    },
    closeSingleDialog() {
      this.singleDialog = false;
    },
    closeGroupDialog() {
      this.groupDialog = false;
    },

    getEvent() {
      this.$http
        .get(this.getApiUrl + "/teacher/schedule", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: this.locale,
          },
        })
        .then((response) => {
          if (response.data.status.error == false) {
            this.events = response.data.data;
          }
        });
    },
    getTeacherInfo() {
      this.$http
        .get(this.getApiUrl + "/teacher/profile", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: this.locale,
          },
        })
        .then((response) => {
          this.teacherInfo = response.data.data;
          this.teacherId = this.teacherInfo.id;
        });
    },

    getRating() {
      this.$http
        .get(this.getApiUrl + "/teacher/evaluation", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: this.locale,
          },
        })
        .then((response) => {
          if (response.data.status.error == false) {
            // console.log(response);
            this.ratingObject = response.data.data;
            this.count = response.data.data.count;
            this.ratingArray = response.data.data.data;
          }
        });
    },

    getSessionsGroups() {
      this.$http
        .get(this.getApiUrl + "/teacher/getGroupsOfTeacher", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: this.locale,
          },
        })
        .then((response) => {
          console.log(response.data.data);
          this.sessionsGroups = response.data.data;
        });
    },
  },
  mounted() {
    this.getEvent();
    this.getTeacherInfo();

    this.getRating();
    if (window.location.protocol == "https:") {
      this.$socket.channel("ScheduleChanged").listen("ScheduleChanged", (e) => {
        console.log(e);
        if (parseInt(e.teacher_id) == parseInt(this.teacherId)) {
          this.getEvent();
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";
@import "../../assets/styles/_responsive.scss";

.details {
  p {
    margin-bottom: 0;
  }
}

.subject-title {
  margin-bottom: 0;
  margin-top: 10px;
}

.student-info {
  margin-right: 0 !important;
  margin-top: 1rem;
  .socials {
    margin-top: 1rem;

    svg {
      font-size: 2rem !important;
      padding: 0 5px;
    }
  }
  p {
    margin-bottom: 0;
    font-size: 0.8rem !important;
  }
}

.editbtn {
  background-color: transparent;
  border: 1px solid $second-color;
  color: $second-color;
  margin-top: 2rem;
}

.rateSection {
  margin-top: 1rem !important;
  .rating {
    margin-top: $margin-top;
    margin-bottom: $margin-bottom;
    .item {
      margin-bottom: 5px;
      p {
        margin-bottom: 0;
      }
    }
  }
}

.chart {
  margin-top: 1rem;
}

.v-card {
  margin-top: 1rem !important;
}
</style>
